import { useCallback } from 'react'
import { map, flatMap } from 'lodash'
import { getPrefix } from '@gql'

const servicePath = '/data-analysis-service/'
const getServiceUrl = endpoint => {
  return window.location.protocol === 'http:'
    ? process.env.REACT_APP_BACKEND_URL + servicePath + endpoint
    : window.location.origin + getPrefix() + servicePath + endpoint
}

const options = content => ({
  method: 'POST',
  mode: 'cors',
  cache: 'no-cache',
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify(content),
})

export function dataAnalysisService(endpoint, context) {
  return fetch(getServiceUrl(endpoint), options(context))
}

export function useDocCheck(checkAPI) {
  const onRuleCheck = useCallback(
    async docs => {
      try {
        const results = await Promise.all(map(docs, checkAPI))
        return map(results, result =>
          flatMap(result, ({ fieldname, result }) =>
            map(result, ([category, message]) => ({
              category,
              label: `${fieldname}: ${message}`,
              pass: false,
            })),
          ),
        )
      } catch (e) {
        return [
          [
            {
              category: 'Error',
              label: `data-analysis-service 錯誤: ${e}`,
              pass: false,
            },
          ],
        ]
      }
    },
    [checkAPI],
  )

  return onRuleCheck
}
